// library imports
import { useState } from "react";
// hook imports
import useFetch from "../hooks/useFetch";

export default function useHasBess() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasBessLoading, setGetHasBessLoading] = useState(false);

  // this state is to check whether the site has BESS
  const [hasBess, setHasBess] = useState(false);

  /* API to check whether site has BESS that is selected and not deleted */
  function getHasBess({ siteSelected }) {
    setGetHasBessLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasDevice",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        device_prefix: "BESS",
      },
      onSuccess: (response) => {
        setGetHasBessLoading(false);
        setHasBess(response.data);
      },
    });
  }

  return [hasBess, getHasBess, getHasBessLoading];
}
